import { ShopFeature } from '../app-types';

type FeaturesRoutesMap = Partial<Record<ShopFeature, string>>;
export const featuresRoutesMap: FeaturesRoutesMap = {
  [ShopFeature.DiscoveryStories]: 'stories',
  [ShopFeature.Collections]: 'collections',
  [ShopFeature.DiscoveryBanner]: 'visual-search/discovery-banner',
  [ShopFeature.FrequentlyBoughtTogether]: 'recommendation-engines/bought-together',
  [ShopFeature.Personalization]: 'recommendation-engines/personalization',
  [ShopFeature.RecentlyViewed]: 'recommendation-engines/recently-viewed',
  [ShopFeature.ShopTheLook]: 'recommendation-engines/shop-the-look',
  [ShopFeature.SimilarItems]: 'recommendation-engines/similar-items',
  [ShopFeature.SimilarByPattern]: 'recommendation-engines/similar-by-pattern',
  [ShopFeature.SocialDiscovery]: 'social-discovery',
  [ShopFeature.AugmentedSearch]: 'text-search/synonyms/languages',
  [ShopFeature.Galleries]: 'galleries',
  [ShopFeature.EmailMarketing]: 'email-marketing-campaigns',
  [ShopFeature.VisualSearch]: 'visual-search',
};
